<template>
  <div class="checklist-table-body" data-locator="table-body">
    <template v-for="section in checklistModel" :key="section.id">
      <ChecklistTableDroppableSection 
        :checklist-model="checklistModel"
        :section="section"
        @drop-after="onDropAfter"
        @drop-to-top="onDropToTop"
      />
    </template>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import { mapActions, mapGetters, mapState } from 'vuex'

  import { toast } from '@/common/utils/toast'
  import { useTranslation } from '@/common/utils/translation'
  import ChecklistTableDroppableSection from '@/project/checklist/table/ChecklistTableDroppableSection.vue'
  import { ChecklistSection } from '@/project/checklist/types'
  import {
  GET_CHECKLIST,
  MOVE_ITEMS,
} from '@/store/modules/checklist/action_types'
import { scrollToMovedItemById } from '@/common/utils/checklist'

  type moveDataType = {
    moveTo?: { id: number; type: string },
    selectedItems: Array<{ id: number; type: string }>,
    moveToRoot?: boolean,
  }
  
  export default defineComponent({
    name: 'ChecklistTableBody',
    props: {
      checklistModel: {
        type: Array as PropType<ChecklistSection[]>,
        required: true,
      },
    },
    components: {
      ChecklistTableDroppableSection,
    },
    setup () {
      return useTranslation({ keyPrefix: 'project.checklist.ChecklistTableBody' })
    },
    computed: {
      ...mapGetters('checklist', [ 'isDraggingSection']),
      ...mapGetters('room', ['roomMnemo']),
      ...mapState('checklist', ['checklistDragItem']),
    },
    methods: {    
      ...mapActions('checklist', [
        GET_CHECKLIST,
        MOVE_ITEMS,
      ]),
      onDropAfter(section: ChecklistSection) {
        this.prepareMoveSection(section)
      },
      onDropToTop() {     
        this.prepareMoveSection()
      },
      async prepareMoveSection(targetItem: ChecklistSection | null = null) {
        if (!this.checklistDragItem || !this.isDraggingSection) {
          return
        }

        const movedItemId = `${this.checklistDragItem.type}-${this.checklistDragItem.id}`
        const targetItemId = targetItem ? `${targetItem.type}-${targetItem.id}` : null

        const moveData: moveDataType = {
          selectedItems: [{
            id: this.checklistDragItem.id,
            type: this.checklistDragItem.type,
          }],
          moveToRoot: true,
        }

        if (targetItem) {
          moveData.moveTo = {
            id: targetItem.id,
            type: targetItem.type,
          }
        }

        try {
          await this.MOVE_ITEMS({
            mnemo: this.roomMnemo,
            data: moveData,
          })

          await this.GET_CHECKLIST(this.roomMnemo)
          scrollToMovedItemById(movedItemId, targetItemId)
          toast.success(this.t('moveItemsSuccess'))
        } catch (e) {
          console.error(e)
          toast.error(this.t('moveItemsError'))
        }
      },
    },
  })
</script>